export default __webpack_public_path__ + "fonts/PencilIcon.svg";